export const BRAND = "A to Z Gift & Craft House";
export const PHONE = "+91 70963 50274";
export const PHONE_LINK = "tel:+917096350274";
export const WHATSAPP = "918107190318";
export const EMAIL = "support@atozgiftandcrafthouse.com";
export const ADMIN_EMAIL = "admin@atozgiftandcrafthouse.com";
export const ADDRESS = "4A, Clive Ghat Street, 4 Grish Chandra Ghosh Lane, 2nd Floor, Vatsalya Chamber, Kolkata 700001";
export const HOURS = "Mon – Sun · 10 AM to 8 PM";

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_WA_MSG = `Hello ${BRAND}! I want to explore your gift collections.`;

export const productWaMsg = (p, extras = {}) => {
  let m = `Hello ${BRAND}! I want to inquire about ${p.name} (${p.sku}) — ${p.category} · ₹${p.price}`;
  if (extras.customName) m += `\nPersonalization: ${extras.customName}`;
  if (extras.qty) m += `\nQuantity: ${extras.qty}`;
  if (extras.date) m += `\nNeeded by: ${extras.date}`;
  return m;
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
